import "./styles.scss";
import React, { FC } from "react";

export const attachmentTypes: string[] = ["google-file", "video"];

interface IProps {
  attachmentType: string,
}

const CompanyAttachmentItem: FC<IProps> = (props: IProps) => {
  const { attachmentType } = props;

  return (
    <div className="ps-company-attachment-item">
      <div className="ps-company-attachment-item__image-container">
        {(attachmentType === attachmentTypes[0]) &&
        <img className="ps-company-attachment-item__google-drive" src="/images/v2-google-drive-icon.png"
             alt="avatar" />}
        {(attachmentType === attachmentTypes[1]) &&
        <img className="ps-company-attachment-item__video" src="/images/v2-blue-video-icon.png" alt="avatar" />}

      </div>
      <span className="ps-company-attachment-item__title">Business Model</span>
    </div>
  );
};

export default CompanyAttachmentItem;
